import Slide from "./_slide.es6";

export default class Main {
  constructor() {
    this._init();
  }

  _init() {
    const slide = new Slide();
  }
}
